/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DataAnalyticsActivitiesRequest } from '../../models/data-analytics-activities-request';
import { DataAnalyticsActivitiesResponse } from '../../models/data-analytics-activities-response';

export interface DataAnalyticsListActivities$Params {
  offset: number;
  limit: number;
      body: DataAnalyticsActivitiesRequest
}

export function dataAnalyticsListActivities(http: HttpClient, rootUrl: string, params: DataAnalyticsListActivities$Params, context?: HttpContext): Observable<StrictHttpResponse<DataAnalyticsActivitiesResponse>> {
  const rb = new RequestBuilder(rootUrl, dataAnalyticsListActivities.PATH, 'post');
  if (params) {
    rb.path('offset', params.offset, {});
    rb.path('limit', params.limit, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DataAnalyticsActivitiesResponse>;
    })
  );
}

dataAnalyticsListActivities.PATH = '/rest/data-analytics/activities/{offset}/{limit}';
